export default {
  getBillOfLandings: (state) => state.billOfLandings,
  getBillOfLanding: (state) => state.billOfLanding,
  pagesCount: (state) => state.pagesCount,
  totalCountData: (state) => state.totalCountData
}
